import Dexie from 'dexie';
// --- external imports ------

const db = new Dexie('TradersDb');
db.version(1).stores({
	inbox: 'id,day,month,year,category,type,seen,saved,number'
});

export default db;
